import { ReactNode } from "react";
import { Grid, Box } from "@mui/material";
import LeftContainer from "src/components/pages/auth/shared/leftContainer";
import useStyles from "./Styles";

interface IProps {
  children: ReactNode;
}
const AuthLayout: React.FC<IProps> = ({ children }) => {
  const { classes } = useStyles();
  return (
    <Grid container className={classes.gridLeft}>
      <Grid
        item
        md={6}
        sx={{
          display: { xs: "none", sm: "none", md: "flex" },
        }}
      >
        <LeftContainer />
      </Grid>
      <Grid item md={6} sm={12} xs={12} className={classes.gridRight}>
        <Box className={classes.rightBoxWrapper}>
          <Box className={classes.rightBoxInnerWrapper}>{children}</Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
